/**
 * Returns the value found inside an object
 * Checks if each object key exists
 * src: https://stackoverflow.com/questions/23808928/javascript-elegant-way-to-check-nested-object-properties-for-null-undefined
 *
 * @param obj
 * @param key
 * @returns {*}
 */
const getObj = function (obj, key) {
  return key.split('.').reduce(function (o, x) {
    return (typeof o === 'undefined' || o === null) ? o : o[x]
  }, obj)
}

export default getObj



// WEBPACK FOOTER //
// ./src/functions/getObj.js